export default "__VITE_ASSET__27cdb4fc__"